export const updateLoguedAction = (state) => {
  return {
    type: "UPDATE_STATE_LOGUED",
    payload: state,
  };
};
